import { useState } from "react";
import { useSelector } from "react-redux";
import Header from "./components/header/header";
import AdminSidebar from "./components/sidebar/AdminSidebar";
import ManagerSidebar from "./components/sidebar/ManagerSidebar";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { role } = useSelector((state) => state.auth);

  const renderSidebar = () => {
    if (role === 3) {
      return <ManagerSidebar collapsed={collapsed} />;
    }

    // super_admin + admin
    return <AdminSidebar collapsed={collapsed} />;
  };

  return (
    <div className="app-wrapper">
      {renderSidebar()}

      <div className={`main-section ${collapsed ? "collapsed" : ""}`}>
        <Header onToggle={() => setCollapsed(!collapsed)} />
        <div className="page-content p-4">{children}</div>
      </div>
    </div>
  );
};

export default Layout;